module.exports = __webpack_public_path__ + "static/media/55_000004.2671c965.jpg";